import { Box, Stack, } from "@mui/material";
import { ReactNode, useEffect } from "react";
import { Outlet } from "react-router-dom";

import { useSideBar } from "./hooks/useSidebar";
import SideMenu from "./SideMenu";
import Header from "../components/organisms/Header";


interface MainLayoutProps {
  headerTitle: string;
  titleClickPath?: string;
  sideMenuContent?: ReactNode;
}

export interface RouteHandle {
  sideMenu?: boolean;
  menuType?: string;
}

const MainLayout = ({
  headerTitle,
  sideMenuContent,
  titleClickPath
}: MainLayoutProps) => {
  const { showSideMenu, enableSideMenu, menuContent, disableSideMenu } = useSideBar();

  useEffect(() => {
    // Always show sidebar if there's menu content for the module
    if (sideMenuContent || menuContent) {
      enableSideMenu(sideMenuContent);
    } else {
      disableSideMenu();
    }
  }, [sideMenuContent, menuContent, enableSideMenu, disableSideMenu])

  return (
    <Stack sx={{
      minHeight: "100vh",
      background: `
        linear-gradient(to right, 
          rgba(232, 119, 34, 0.9) 0%, 
          rgba(232, 119, 34, 0.7) 15%, 
          rgba(232, 119, 34, 0.3) 30%, 
          transparent 50%
        ),
        url("/assets/images/backgroundImage.png")
      `,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundAttachment: "fixed",
    }}>
      <Stack direction="column" sx={{ width: { xs: "90%", sm:"90%",md:"90%",lg:"90%", xl: "90%" }, margin: "0 auto", alignItems: "center", height: "100vh", }}>
        <Header
          title={headerTitle}
          titleClickPath={titleClickPath}
        />
        <Stack direction="row" sx={{
          overflow: "hidden",
          backgroundColor: "white",
          borderTopLeftRadius: "16px",
          borderTopRightRadius: "16px",
          width: "100%",
          flex: 1,
          minHeight: 0
        }}>
          {(menuContent || sideMenuContent) && (
            <SideMenu />
          )}

          <Box sx={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            minWidth: 0,
            overflow: "hidden"
          }}>
            {/* {hasSideMenu && (
            <Paper elevation={0} sx={{
              background: "white",
              borderRadius: 0,
              height: "100px",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              width: "100%",
              flexShrink: 0
            }}>
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start", marginLeft: "32px", gap: 2, my: "24px" }}>
                <Typography component="h3">{headerTitle}</Typography>
                <Typography component="div">Manage your leads and track performance</Typography>
              </Box>
            </Paper>
          )} */}

            <Box sx={{
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
              flex: 1,
              minHeight: 0
            }}>
              <Outlet />
            </Box>
          </Box>

        </Stack>
      </Stack>
    </Stack>
  );
};

export default MainLayout;


